import { render } from "./OperationIntro.vue?vue&type=template&id=0fc7dcc7"
import script from "./OperationIntro.vue?vue&type=script&lang=js"
export * from "./OperationIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__